module.exports = __webpack_public_path__ + "static/media/messageSender.6b631572.svg";